import { isPasswordValid } from "@calcom/lib/auth/isPasswordValid";
import { emailRegex } from "@calcom/lib/emailSchema";
import { z } from "zod";

export const signupSchema = z.object({
  username: z.string().optional(),
  email: z.string().regex(emailRegex, { message: "Invalid email" }),
  password: z.string().superRefine((data, ctx) => {
    const result = isPasswordValid(data, true, false);
    for (const key of Object.keys(result)) {
      if (!result[key as keyof typeof result]) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [key],
          message: key,
        });
      }
    }
  }),
  language: z.string().optional(),
  token: z.string().optional(),
});
